import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Dialog, DialogTitle } from '@material-ui/core';
import { injectIntl } from "react-intl";

import messages from "./messages";

const useStyles = makeStyles({
  float: {
    float:'right',
  },
});

const PopupModal = props => {
  const {
    intl: { formatMessage },
    message,
    onClose,
    open,
    removeErrorTitle,
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Box pb={2}>
        {!removeErrorTitle && <DialogTitle>{formatMessage(messages.error)}</DialogTitle>}
        <Box mt={removeErrorTitle ? 3 : 0} pl={3} pr={3}>
          {message}
          <Box mt={1}>
            <Button
              className={classes.float}
              color="primary"
              onClick={onClose}
            >
              {formatMessage(messages.ok)}
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default injectIntl(PopupModal);
